export const CLAIM_STATUS = {
  SUBMITTED: 'Submitted',
  UNDER_REVIEW: 'Under Review',
  DOCUMENTATION_REQUIRED: 'Documentation Required',
  INVESTIGATION: 'Investigation',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  SETTLED: 'Settled',
};

export const USER_ROLE = {
  CLIENT: 'client',
  BROKER: 'broker',
  ADMIN: 'admin',
};

export const CLAIM_TYPES = [
  'Motor Insurance',
  'Home Insurance',
  'Health Insurance',
  'Life Insurance',
  'Property Damage',
  'Liability',
  'Workers Compensation',
  'Travel Insurance',
  'Other',
];

export const PROVIDER_TYPES = [
  'Hospitals',
  'Dental Clinic',
  'Eye Clinic/Ophthalmologist',
  'Others',
];

export const PRIORITY_LEVELS = [
  { value: 'low', label: 'Low', color: 'slate' },
  { value: 'normal', label: 'Normal', color: 'blue' },
  { value: 'high', label: 'High', color: 'orange' },
  { value: 'urgent', label: 'Urgent', color: 'red' },
];

export const getStatusColor = (status) => {
  const colors = {
    [CLAIM_STATUS.SUBMITTED]: 'bg-blue-100 text-blue-700 border-blue-200',
    [CLAIM_STATUS.UNDER_REVIEW]: 'bg-yellow-100 text-yellow-700 border-yellow-200',
    [CLAIM_STATUS.DOCUMENTATION_REQUIRED]: 'bg-orange-100 text-orange-700 border-orange-200',
    [CLAIM_STATUS.INVESTIGATION]: 'bg-purple-100 text-purple-700 border-purple-200',
    [CLAIM_STATUS.APPROVED]: 'bg-green-100 text-green-700 border-green-200',
    [CLAIM_STATUS.REJECTED]: 'bg-red-100 text-red-700 border-red-200',
    [CLAIM_STATUS.SETTLED]: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  };
  return colors[status] || 'bg-slate-100 text-slate-700';
};

export const getPriorityColor = (priority) => {
  const colors = {
    low: 'bg-slate-100 text-slate-700',
    normal: 'bg-blue-100 text-blue-700',
    high: 'bg-orange-100 text-orange-700',
    urgent: 'bg-red-100 text-red-700',
  };
  return colors[priority] || 'bg-slate-100 text-slate-700';
};

export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export const formatDateTime = (dateString) => {
  return new Date(dateString).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: 'NGN',
  }).format(amount);
};
